






















































































































































































































































































































































import {
  PropType,
  computed,
  defineComponent,
  getCurrentInstance,
  Ref,
  ref,
  toRefs,
  watch,
  reactive,
} from '@vue/composition-api';
import {
  ChevronDownIcon,
  ChevronRightIcon,
  HelpCircleIcon,
  SearchIcon,
  LoadingIcon,
  CheckCircleIcon,
  ErrorCircleIcon,
  UsergroupIcon,
  UserIcon,
  SwapIcon,
  AddCircleIcon,
} from 'tdesign-icons-vue';
import _ from 'lodash';

import CoLevelHelp, { helpHandler } from '@/renderer/components/dialog/AddTransfer/components/coLevelHelp.vue';
import PermissionTable from '@/renderer/components/dialog/AddTransfer/AddFileAuth/components/permissionTable.vue';
import { isDisabledAllAuth } from '@/renderer/scripts/utils/tools/index';
import { checkRoleIsAdmin } from '@/renderer/scripts/utils/UserRole';
import { SMH } from '@/renderer/scripts/smh';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';
import { isAdminOrSuperAdmin } from '@/renderer/scripts/utils/UserRole/getters';
import { showPhoneOrAccountName } from '@/renderer/components/dialog/AddTransfer/compositions/useTools';
import useOrgTreeStructure from '@/renderer/components/dialog/AddTransfer/compositions/useOrgTreeStructure';
import searchHandler from '@/renderer/components/dialog/AddTransfer/compositions/searchHandler';
import authHandler, { AuthParams, AuthOptions } from '@/renderer/components/SpacePage/compositions/authHandler';
import useOperation from '@/renderer/components/dialog/AddTransfer/AddFileAuth/compositions/useOperation';
import i18n, { i18n_t } from '@/locales/i18n';
import tips from '@/renderer/scripts/utils/tips';
import { sleep } from '@/renderer/scripts/utils/tools';

interface AuthParamsContent {
  params: AuthParams;
  options?: AuthOptions;
}

interface PropTypes {
  show: boolean;
  spaceId: string;
  authParams: AuthParamsContent;
  type: string;
  defaultRoleId: number;
  noRemoveTip: boolean;
  noDisableRoleSelect: boolean;
  showPhoneNumber: boolean;
  allowInactiveUser: boolean;
  teamId?: number;
  canAdminSetRole?: boolean;
}
export interface SubmitEvent {
  changed?: CoFile.TeamOrMemberItem[];
  deleted?: CoFile.TeamOrMemberItem[];
  added?: CoFile.TeamOrMemberItem[];
}
export interface PermissionData {
  inheritMember: CoFile.TeamOrMemberItem[];
  authorizeMember: CoFile.TeamOrMemberItem[];
  forbiddenMember: CoFile.TeamOrMemberItem[];
}
export default defineComponent({
  components: {
    HelpCircleIcon,
    SearchIcon,
    LoadingIcon,
    CheckCircleIcon,
    ErrorCircleIcon,
    UsergroupIcon,
    UserIcon,
    SwapIcon,
    CoLevelHelp,
    ChevronDownIcon,
    ChevronRightIcon,
    AddCircleIcon,
    PermissionTable,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    spaceId: String,
    // 查询共享授权的参数
    authParams: {
      required: true,
      type: Object as PropType<AuthParamsContent>,
    },
    attach: {
      type: String,
      default: 'body',
    },
    defaultRoleId: {
      type: Number,
    },
    noDisableRoleSelect: {
      type: Boolean,
      default: false,
    },
    showOverlay: {
      type: Boolean,
      default: true,
    },
    // 是否允许操作未激活的用户
    allowInactiveUser: {
      type: Boolean,
      default: false,
    },
    showPhoneNumber: {
      type: Boolean,
      default: false,
    },
    showTemporaryMember: {
      type: Boolean,
      default: false,
    },
    // 是否允许管理员设置权限
    canAdminSetRole: {
      type: Boolean,
      default: false,
    },
    /**
     * type=shareFile时且操作的是企业空间的文件时需要。
     * 当teamId有值时表示当前添加共享成员是在哪个团队下进行操作的。
     * 目的是为了能查出成员内有哪些是当前团队的团队管理员，从而只能授权为操作者权限。
     */
    teamId: Number,
  },
  filters: {
    formatTag(tag: number) {
      const map: Record<number, string> = {
        1: i18n_t('继承'),
        2: i18n_t('继承'), // FIX: 默认权限也显示为继承
      };

      return map[tag];
    },
  },
  setup(props: PropTypes, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = vm.$store;
    const routeName = computed(() => vm.$route.name as string);
    const currTeamId = ref<number | undefined>(); // 表示当前弹窗是对企业空间的某个文件/文件夹操作(个人空间、协作空间则为空)
    const currUserId = computed(() => store.getters.userId);

    const innerShow: Ref<boolean> = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });

    const currentSpaceId = computed(() => props.spaceId);
    const tip = i18n_t('团队或成员');
    const isOnlySearchUser = computed(() => !store.getters.enableViewAllOrgUser && !isAdminOrSuperAdmin.value);
    const showPhoneNumber = computed(() => props.showPhoneNumber);
    const { allowInactiveUser } = toRefs(props);
    const confirming = ref(false);

    const {
      treeKeys,
      rootTeamId,
      teamData,
      hasMoreUser,
      loadLimit,
      loading: treeLoading,
      methods: treeMethods,
    } = useOrgTreeStructure({
      showPhoneNumber: showPhoneNumber.value,
    });

    const {
      loading: authLoading,
      dirPermisionList: originPermission,
      hasMore: authHasMore,
      methods: authMethods,
    } = authHandler(currentSpaceId);

    const {
      roleLoading,
      addedMembers,
      addedMembersSet,
      originAddedMembersSet,
      checkedControl,
      checkAllChange,
      methods: operationMethods,
    } = useOperation({
      allowInactiveUser,
      originAddedMembers: originPermission,
      getTeamMemberTree: treeMethods.getTeamMemberTree,
    });

    const {
      teamData: searchTeamData,
      memberData: searchMemberData,
      loadingStatus,
      loading: searchLoading,
      searchKey,
      collapseExpand: searchCollapseExpand,
      methods: searchMethods,
    } = searchHandler({
      onlySearchUser: isOnlySearchUser.value,
      showPhoneNumber: showPhoneNumber.value,
    });

    const { show: showHelp, openHelp } = helpHandler();

    const renderPermissionsList = computed(() => {
      const filterPermissionList = addedMembers.value.sort((a, b) => {
        // 不支持操作的排序到最前
        if (a.disabledOperate && !b.disabledOperate) return -1;
        return 1;
      });
      return filterPermissionList;
    });

    const renderRoleList = computed(() =>
      (vm.$store.getters.roles as SMH.Role[]).filter(role => {
        if (['teamManagement'].includes(routeName.value)) {
          // 团队管理页面隐藏禁止访问者入口
          return !role.name.includes(i18n_t('禁止访问者'));
        }
        // 协作空间权限详情不显示操作者行
        return !routeName.value.includes('collaborationSpace') || (!role.canAuthorize && !isDisabledAllAuth(role));
      }),
    );

    const confirm = (callback: Function) => {
      const dialog = CustomDialog.confirm({
        header: i18n_t('提示'),
        body: i18n_t('操作未提交，确定要关闭窗口吗？'),
        theme: 'warning',
        onConfirm: () => {
          if (dialog.hide) {
            dialog.hide();
            callback();
          }
        },
      });
    };

    const methods = {
      async init() {
        const routeQueryTeamId = vm.$route.query?.teamId;
        currTeamId.value = props.teamId || (routeQueryTeamId ? +routeQueryTeamId : undefined);
        operationMethods.initRoleList();
        // 初始化右侧
        await methods.initOriginPermission();
        // 初始化左侧
        treeMethods.initData();
      },
      // 初始化查询右侧授权列表
      async initOriginPermission() {
        const { authParams } = props;
        const { params, options } = authParams;
        await authMethods.initAuthDir(params, options);
      },
      validateRole() {
        return addedMembers.value.some(item => typeof item.roleId === 'string');
      },
      async onConfirm() {
        if (confirming.value) return;
        confirming.value = true;
        tips.loading(i18n_t('处理中，请稍后...'), 0);
        // 保证先提示tips 延迟200ms处理后面的逻辑
        await sleep(200);
        if (methods.validateRole()) {
          tips.error(
            i18n_t('请设置{slot1}的权限', {
              slot1: tip,
            }),
          );
          confirming.value = false;
          return;
        }
        const res = operationMethods.filterPermisionList();
        const noChanged = res.added.length === 0 && res.changed.length === 0 && res.deleted.length === 0;
        if (checkedControl.value.number && noChanged) {
          tips.error(i18n_t('选择成员不可被修改'));
          confirming.value = false;
          return;
        }
        if (noChanged) {
          tips.error(
            i18n_t('请选择至少一个{slot1}', {
              slot1: tip,
            }),
          );
          confirming.value = false;
          return;
        }
        const successful = await authMethods.onConfirmAuth(res);
        context.emit('onSaved', successful);
        confirming.value = false;
        if (successful) {
          innerShow.value = false;
        }
      },
      onClose() {
        if (methods.validateRole()) {
          confirm(() => {
            innerShow.value = false;
          });
          return;
        }
        const res = operationMethods.filterPermisionList();
        if (res.changed.length > 0 || res.deleted.length > 0) {
          confirm(() => {
            innerShow.value = false;
          });
        } else {
          innerShow.value = false;
        }
      },
      handleRemoveMember(params: { index: number; item: CoFile.TeamOrMemberItem }) {
        const { index, item } = params;
        operationMethods.removeTeamOrMember(index, item);
      },
      handleRemoveMembers() {
        operationMethods.removeTeamOrMembers();
      },
      handleSelectAll(checked: boolean) {
        Object.assign(checkAllChange, { checked, t: Date.now() });
      },
      onSearchTeamsOrMembers(value: string) {
        searchMethods.onSearchTeamsOrMembers(value, rootTeamId.value, currTeamId.value);
      },
      /**
       * 管理员身份的成员是否允许展示添加操作
       */
      ifAdminUserShowAddOperate(role: string) {
        return props.noDisableRoleSelect || !checkRoleIsAdmin(role);
      },
      isCurrentUser(user: CoFile.TeamOrMemberItem) {
        if (user.userId && user.userId === currUserId.value) {
          return true;
        }
        return false;
      },

      loadMoreAuthData() {
        if (authLoading.value || !authHasMore.value) return;
        authMethods.getDirPermissions();
      },
      // 表格内选中项改动
      permissionTableCheckChanged(selectedAuthList: number[]) {
        addedMembers.value.forEach((item: any) => {
          item.checked = selectedAuthList.includes(item.uid);
        });
      },
      addedStatus(item: CoFile.TeamOrMemberItem) {
        let status = '';
        const treeId = item.uid;
        if (treeId) {
          if (originAddedMembersSet.has(treeId) && addedMembersSet.has(treeId)) {
            status = 'originAdd';
          } else if (addedMembersSet.has(treeId)) {
            status = 'newAdd';
          }
        }
        return status;
      },
    };

    methods.init();

    watch(
      () => originPermission.value,
      (val, old) => {
        if (val.length !== old.length && innerShow.value) {
          operationMethods.initOriginAdded();
        }
      },
    );

    return {
      innerShow,
      tip,
      isOnlySearchUser,

      currTeamId,
      checkedControl,
      checkAllChange,
      treeLoading,
      hasMoreUser,
      loadLimit,
      rootTeamId,
      roleLoading,
      treeKeys,
      treeMethods,
      ...toRefs(teamData),

      renderRoleList,
      renderPermissionsList,

      loadingStatus,
      searchLoading,
      searchKey,
      searchCollapseExpand,
      searchTeamData,
      searchMemberData,
      searchMethods,

      ...methods,

      showPhoneOrAccountName,
      showHelp,
      openHelp,
      checkRoleIsAdmin,

      addedMembers,
      operationMethods,

      authLoading,
      authHasMore,
      originPermission,
      authMethods,
    };
  },
});
